import stringify from 'fast-json-stable-stringify';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hashKey = (object: any): string => stringify(object);
